/**
 * External dependencies
 */
import React from "react"
import Select from "react-select"

/**
 * Internal dependencies
 */
import "./styles/_index.scss"

const style = {
  control: base => ({
    ...base,
    boxShadow: "none",
    border: "none",
  }),
}

const CustomSelect = ({
  placeholderValue,
  options,
  classNamePrefix,
  className,
  onSelectClick,
  DefaultValue,
  value
}) => {
  return (
    <Select
      isSearchable={false}
      styles={style}
      options={options}
      classNamePrefix={classNamePrefix || "custom-select"}
      className={className || "custom-select"}
      onChange={onSelectClick}
      value={value}
      defaultValue={DefaultValue}
      placeholder={
        <div className="custom-select__placeholder"> {placeholderValue}</div>
      }
    />
  )
}

export default CustomSelect
